export class WbVideo {
  constructor() {
    this.init();
  }

  init() {
    return new Promise((resolve, reject) => {
      this.bindListeners();
      resolve();
    });
  }

  bindListeners() {
    const _this = this;

    document
      .querySelector('body')
      ._addCustomEventListener('click', '.wb-video__play', _this.togglePlay.bind(_this));
    document
      .querySelector('body')
      ._addCustomEventListener('click', '.wb-video__pause', _this.togglePlay.bind(_this));
    document
      .querySelector('body')
      ._addCustomEventListener('click', '.wb-video__mute', _this.toggleSound.bind(_this));
  }

  togglePlay(e) {
    const _this = this;
    const ele = e.targetElement;
    const wrapper = ele.closest?.('.wb-video');

    if (ele.classList.contains('wb-video__play'))
      document.querySelectorAll?.('.wb-video--playing')?.forEach(video => {
        _this.changeVideoStatus(video);
      });

    _this.changeVideoStatus(wrapper);
  }

  changeVideoStatus(parent) {
    const videoPlayer = parent?.querySelector('.wb-video__video-player');
    const controls = parent?.querySelectorAll('.wb-video__controls__btn');

    if (videoPlayer) {
      if (parent.classList.contains('wb-video--playing')) {
        videoPlayer.pause();
        parent.classList.remove('wb-video--playing');
      } else {
        videoPlayer.play();
        parent.classList.add('wb-video--playing');
      }

      controls?.forEach(control => {
        control?._slideToggle();
      });
    }
  }

  toggleSound(e) {
    const ele = e.targetElement;
    const wrapper = ele.closest?.('.wb-video');
    const videoPlayer = wrapper?.querySelector('.wb-video__video-player');

    if (videoPlayer) {
      wrapper.classList.toggle('wb-video--muted');
      videoPlayer.muted = wrapper.classList.contains('wb-video--muted');
    }
  }
}
